module.exports = __webpack_public_path__ + "static/media/next.d341d700.svg";